import { useContext } from "react";
import { MachineSetupContextUpdater } from "./MachineSetupContextProvider";

const useMachineSetupContextUpdater = () => {
   const context = useContext(MachineSetupContextUpdater);
   if (context === undefined) {
      throw new Error("useMachineSetupContextUpdater was used outside of it's provider");
   }
   return context;
}

export { useMachineSetupContextUpdater }; 